import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const updatedAccountPerksSelector = createSelector(testTargetOffersSelector, offers => offers.updatedAccountPerks || Empty.Object);

export { updatedAccountPerksSelector };
